import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestPendingList = ({ pageNumber }) => {
  let getUrl = '/user/history/pending';
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestShippedList = ({ pageNumber }) => {
  let getUrl = '/user/history/shipped';
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};
const requestUndecidedList = ({ pageNumber }) => {
  let getUrl = '/user/history/undecided';
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestDownloadedList = ({ pageNumber }) => {
  let getUrl = '/user/history/downloaded';
  if (pageNumber) {
    getUrl += `/${pageNumber}`;
  }
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestMarketList = ({ csrfToken, page = 1, postParams }) => {
  const result = apiClient.post(
    `/user/history/market/${page}`,
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestPendingList,
  requestShippedList,
  requestUndecidedList,
  requestDownloadedList,
  requestMarketList,
};
